import { ExtractPropTypes } from 'vue'

export const centerScrollProps = {
	/**
	 * 数据源
	 */
	data: {
		type: [Array, String],
		required: true,
		default: () => []
	},
	/**
	 * 模式
	 */
	mode: {
		type: String,
		default: ''
	},
	/**
	 * 当前选中的值
	 */
	modelValue: {
		type: [String, Number],
		default: ''
	},
	/**
	 * 高度（单位em，建议使用 3 的奇数倍数）
	 */
	height: {
		type: [String, Number],
		default: 17
	}
}

export const centerScrollEmits = {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	'update:modelValue': (value: string | number) => true,
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	change: (value: string | number) => true
}

export type CenterScrollProps = ExtractPropTypes<typeof centerScrollProps>
export type CenterScrollEmits = typeof centerScrollEmits

export interface CenterScrollDataItem {
	label: string
	value: string | number
	disabled?: boolean
}

export interface CenterScrollInstance {
	scrollTo: (element: HTMLElement, behavior?: ScrollBehavior) => void
	centerClosestItem: () => void
}
